import Vue from 'vue';
import VueI18n from 'vue-i18n';
// import numberFormats from '@/locales/numerFormatter';

Vue.use(VueI18n)

import es from '@/locales/es';

export default {
	es
}